import React from "react";
import AppFooterView from "./view";
import { useAuth } from "../../../context/AuthProvider";

export default function AppFooter() {
  const { metaData } = useAuth();

  return <AppFooterView version={{ api: metaData?.version }} />;
}
